import { useState } from "react";
import { useTokens } from "../../lib/queries";
import { fmtUsd, fmtPrice, fmtAmt, short } from "../../lib/format";
import { TrustPanel } from "./TrustPanel";

export const TokenScanner = () => {
  const { data: tokens } = useTokens();
  const [sel, setSel] = useState(null);
  const token = tokens?.find((t) => t.symbol === sel) || tokens?.[0];
  const tone = (s) => (s < 25 ? "text-pos" : s < 50 ? "text-warn" : "text-neg");
  return (
    <section className="panel flex-1 min-h-0 flex flex-col max-lg:h-auto max-lg:flex-none" data-testid="token-scanner-container">
      <div className="panel-head"><h2 className="panel-title">Token trust · Pons scanner</h2><span className="mono text-[11px] text-fog">{tokens?.length ?? 0} stock-paired tokens</span></div>
      <div className="flex-1 min-h-0 grid grid-cols-1 xl:grid-cols-[1fr_380px] max-lg:block">
        <div className="overflow-auto border-r border-line max-lg:border-r-0 max-lg:border-b">
          <table className="w-full min-w-[860px] text-xs">
            <thead className="sticky top-0 bg-s1"><tr className="eyebrow text-left [&>th]:px-3 [&>th]:h-8 [&>th]:font-normal border-b border-line"><th>Token</th><th>Pair</th><th className="text-right">Pool depth</th><th className="text-right">Price · USD/M</th><th className="text-right">Top 10</th><th className="text-right">Deployer</th><th className="text-right">Holders</th><th className="text-right">Age</th><th>LP</th><th className="text-right">Risk</th></tr></thead>
            <tbody>
              {(tokens || []).map((t) => (
                <tr key={t.symbol} onClick={() => setSel(t.symbol)} data-testid={`scanner-row-${t.symbol}`} className={`row-hover border-b border-line/60 mono [&>td]:px-3 [&>td]:h-10 ${token?.symbol === t.symbol ? "bg-violet/10 shadow-[inset_2px_0_0_#C026F5]" : ""}`}>
                  <td><div className="font-heading font-semibold text-white text-sm">{t.symbol}</div><div className="text-[10px] text-fog">{t.name} · {short(t.address)}</div></td>
                  <td><span className="tag border-violet/40 text-violet-300">/{t.stock}</span></td>
                  <td className="text-right">{fmtUsd(t.pool_depth_usd)}</td><td className="text-right">{fmtPrice(t.pool_price_usd)}</td>
                  <td className={`text-right ${t.top10_pct > 45 ? "text-neg" : t.top10_pct > 30 ? "text-warn" : "text-pos"}`}>{t.top10_pct.toFixed(1)}%</td>
                  <td className="text-right">{t.deployer_pct.toFixed(1)}%</td><td className="text-right text-fog">{fmtAmt(t.holder_count)}</td>
                  <td className="text-right text-fog">{t.age_hours < 48 ? `${t.age_hours.toFixed(0)}h` : `${(t.age_hours / 24).toFixed(1)}d`}</td>
                  <td><span className="tag border-pos/40 text-pos">locked</span></td>
                  <td className={`text-right font-semibold ${tone(t.risk_score)}`}>{t.risk_label}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="overflow-auto">{token && <TrustPanel token={token} />}</div>
      </div>
    </section>
  );
};
